import * as yup from "yup";
import { emailCheck, phoneCheck } from "../../common/regex";
import { join } from "path";
import { EmployeeData } from "../interfaces/ApiResponse.interface";

export const validationSchema:yup.ObjectSchema<EmployeeData> = yup.object().shape({
  employeeDetails: yup.object().shape({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    mobileNumber: yup
      .string()
      .required("Mobile Number is required")
      .matches(phoneCheck, "Please enter a valid phoneNumber"),
    emailId: yup
      .string()
      .trim()
      .required("Email is required")
      .matches(emailCheck, "Invalid email address"),
    joiningDate: yup.date().required("Joining Date is required"),
    alternativePhoneNumber: yup
      .string()
      .matches(phoneCheck, "Please enter a valid phoneNumber"),
    alternativeEmailId: yup
      .string()
      .trim()
      .matches(emailCheck, "Invalid email address"),
    relationWithEmployee: yup
      .string()
      .required("Relation with Employee is required"),
    aadhaarNumber: yup
      .string()
      .optional()
      .matches(/^\d{12}$/, "Aadhaar Number must be 12 digits"),
    panNumber: yup
      .string()
        .optional()
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Number format"),
    
  }),
  personalDetails: yup.object().shape({
    dob: yup.date().required("Date of Birth is required"),
    bloodGroup: yup
      .string()
        .required("Blood Group is required")
        .oneOf(
            ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"],
            "Invalid Blood Group"
        ),
    gender: yup
      .string()
      .required("Gender is required")
      .oneOf(["Male","Female", "Other"], "Invalid Gender"),
    maritalStatus: yup
      .string()
        .required("Marital Status is required")
        .oneOf(["Single", "Married", "Divorced", "Widowed"], "Invalid Marital Status"),
    
        
  }),
  addressDetails: yup.object().shape({
    addressLine1: yup.string().required("Address Line 1 is required"),
    addressLine2: yup.string(),
    city: yup.string().required("City is required"),
    state: yup.string().required("State is required"),
    country: yup.string().required("Country is required"),
    pincode: yup
      .string()
      .required("Pincode is required")
      .matches(/^\d{6}$/, "Pincode must be 6 digits"),
  }),
  bankDetails: yup.object().shape({
    accountHolderName: yup.string().required("Account Holder Name is required"),
    accountNumber: yup.string().required("Account Number is required"),
    ifscCode: yup.string().required("IFSC Code is required"),
    bankName: yup.string().required("Bank Name is required"),
    branchName: yup.string().required("Branch Name is required"),
    upiNumber: yup
      .string()
      .optional()
      .test(
        "is-valid-upi-number",
        "Please enter a valid UPI number",
        (value) => !value || phoneCheck.test(value)
      ),

    upiAddress: yup
      .string()
      .optional()
      .test(
        "is-valid-upi-id",
        "Please enter a valid UPI ID",
        (value) => !value || /^[a-zA-Z0-9._-]+@[a-zA-Z]+$/.test(value)
      ),
  }),
});
